// export const apiURL = "https://sundialhome.herokuapp.com/api/";
export const apiURL = "https://sundial-test.herokuapp.com/api/";
// export const apiURL = "http://localhost:3001/api/";
// export const apiURL =
//   "http://ec2-18-191-178-245.us-east-2.compute.amazonaws.com:3001/api/";
